// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `zxing-scanner {
  height: 100%;
  overflow: hidden;
  min-height: -webkit-fill-available;
  object-fit: contain;
}

:host zxing-scanner::ng-deep video {
  aspect-ratio: 1;
  height: 100%;
}

.scanner {
  position: relative;
  height: 100%;
}

.focus-box-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 250px;
  height: 250px;
  transform: translate(-50%, -50%);
  border: 2px solid white;
  box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.5);
  z-index: 10;
}

.scan-line {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  height: 2px;
  background-color: red;
  z-index: 11;
  animation: scan 2s infinite cubic-bezier(0.5, 0, 0.5, 1);
}

@keyframes scan {
  0% {
    top: 25%;
  }
  100% {
    top: 75%;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/scan-qr/scan-qr.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,gBAAA;EACA,kCAAA;EACA,mBAAA;AACF;;AAEA;EACE,eAAA;EACA,YAAA;AACF;;AACA;EACE,kBAAA;EACA,YAAA;AAEF;;AAAA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;EACA,gCAAA;EACA,uBAAA;EACA,2CAAA;EACA,WAAA;AAGF;;AADA;EACE,kBAAA;EACA,QAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,qBAAA;EACA,WAAA;EACA,wDAAA;AAIF;;AADA;EACE;IACE,QAAA;EAIF;EAFA;IACE,QAAA;EAIF;AACF","sourcesContent":["zxing-scanner {\r\n  height: 100%;\r\n  overflow: hidden;\r\n  min-height: -webkit-fill-available;\r\n  object-fit: contain;\r\n}\r\n\r\n:host zxing-scanner::ng-deep video {\r\n  aspect-ratio: 1;\r\n  height: 100%\r\n}\r\n.scanner {\r\n  position: relative;\r\n  height: 100%;\r\n}\r\n.focus-box-overlay {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  width: 250px;\r\n  height: 250px; \r\n  transform: translate(-50%, -50%);\r\n  border: 2px solid white;\r\n  box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.5);\r\n  z-index: 10;\r\n}\r\n.scan-line {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 0;\r\n  right: 0;\r\n  height: 2px;\r\n  background-color: red;\r\n  z-index: 11;\r\n  animation: scan 2s infinite cubic-bezier(0.5, 0, 0.5, 1);\r\n}\r\n\r\n@keyframes scan {\r\n  0% {\r\n    top: 25%;\r\n  }\r\n  100% {\r\n    top: 75%;\r\n  }\r\n}\r\n\r\n// zxing-scanner {\r\n//   height: 100%;\r\n//   width: 100%;\r\n//   position: absolute;\r\n//   top: 0px;\r\n//   bottom: 0;\r\n//   left: 0px;\r\n//   right: 0;\r\n//   object-fit: contain;\r\n//   overflow: hidden;\r\n// }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
